import styled from 'styled-components'

import { palette } from '_styles/variables'

export const Input = styled.input`
  appearance: none;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  height: 100%;
  opacity: 1;
  position: absolute;
  width: 100%;
  &:checked {
    background-color: rgba(0, 0, 0, 0);
  }
  &:checked::after {
    background-color: rgba(0, 0, 0, 0);
  }
  &:focus {
    outline: 1px solid ${palette.brand.newPurple};
  }
`
